import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface FailedFile {
  fileName: string;
  s3FileName: string;
  urlImage?: string;
  checkBox: boolean;
}

interface FailedFilesState {
  files: FailedFile[];
  inquirySent: boolean;
}

const initialState: FailedFilesState = {
  files: [],
  inquirySent: false,
};

export const failedFilesSlice = createSlice({
  name: "failedFiles",
  initialState,
  reducers: {
    addFailedFiles: (state, action: PayloadAction<FailedFile[]>) => {
      state.files = [...state.files, ...action.payload];
      state.inquirySent = false;
    },
    toggleFailedFileCheck: (state, action: PayloadAction<string>) => {
      const target = state.files.find(
        (f) => f.s3FileName === action.payload
      );
      if (target) target.checkBox = !target.checkBox;
    },
    markInquirySent: (state) => {
      state.inquirySent = true;
    },
    resetFailedFiles: () => initialState,
  },
});

export const {
  addFailedFiles,
  toggleFailedFileCheck,
  markInquirySent,
  resetFailedFiles,
} = failedFilesSlice.actions;

export const selectFailedFiles = (state: RootState) =>
  state.failedFiles.files;
export const selectInquirySent = (state: RootState) =>
  state.failedFiles.inquirySent;
export const selectCheckedFailedFiles = (state: RootState) =>
  state.failedFiles.files.filter((f) => f.checkBox);

export default failedFilesSlice.reducer;
